export const Types = {
  GEO: 'geo'
}

/**
 * Service that handles report reference data file operations
 */
export class ReportReferenceDataFileService {
  /**
   * Get the filename of the reference data based on the type and params
   * The params are type contextual
   *
   * @param {string} type Reference data type
   * @param {object} params Reference data params
   * @returns {string|undefined} Filename
   */
  getFilename (type, params) {
    let filename
    switch (type) {
      case Types.GEO:
        const { region, regionLevel, subgroup } = params
        filename = `geography/${region}/${regionLevel}/${subgroup}.json`
        break
    }

    return filename
  }
}

export const reportReferenceDataFileService = new ReportReferenceDataFileService()
